// Type guard to check if we're in a Vite environment
const isViteEnvironment = () => {
  try {
    return typeof window !== 'undefined' && (window as any)?.isViteEnv && (import.meta as any).env;
  } catch {
    return false;
  }
};

// Type guard to check if we're in a Node environment
const isNodeEnvironment = () => {
  try {
    return typeof process !== 'undefined' && process.env;
  } catch {
    return false;
  }
};

export default function getEnvMode() {
  if (isViteEnvironment()) {
    // In browser environment, default to development
    return 'production';
  }

  if (isNodeEnvironment()) {
    return process.env.NODE_ENV || 'development';
  }

  return 'development';
}
